import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { settings } from '@pixi/settings';
import { Program } from '../shader/Program.mjs';
import { Shader } from '../shader/Shader.mjs';
import { State } from '../state/State.mjs';
import defaultFragment from './defaultFilter.mjs';
import defaultVertex from './defaultFilter2.mjs';
var Filter = /*#__PURE__*/function (_Shader) {
  _inherits(Filter, _Shader);
  var _super = _createSuper(Filter);
  function Filter(vertexSrc, fragmentSrc, uniforms) {
    var _this;
    _classCallCheck(this, Filter);
    var program = Program.from(vertexSrc || Filter.defaultVertexSrc, fragmentSrc || Filter.defaultFragmentSrc);
    _this = _super.call(this, program, uniforms);
    _this.padding = 0;
    _this.resolution = settings.FILTER_RESOLUTION;
    _this.multisample = settings.FILTER_MULTISAMPLE;
    _this.enabled = true;
    _this.autoFit = true;
    _this.state = new State();
    return _this;
  }
  _createClass(Filter, [{
    key: "apply",
    value: function apply(filterManager, input, output, clearMode, _currentState) {
      filterManager.applyFilter(this, input, output, clearMode);
    }
  }, {
    key: "blendMode",
    get: function get() {
      return this.state.blendMode;
    },
    set: function set(value) {
      this.state.blendMode = value;
    }
  }, {
    key: "resolution",
    get: function get() {
      return this._resolution;
    },
    set: function set(value) {
      this._resolution = value;
    }
  }], [{
    key: "defaultVertexSrc",
    get: function get() {
      return defaultVertex;
    }
  }, {
    key: "defaultFragmentSrc",
    get: function get() {
      return defaultFragment;
    }
  }]);
  return Filter;
}(Shader);
export { Filter };